import { render, staticRenderFns } from "./TftBracketsContainer.vue?vue&type=template&id=707ba9d6"
import script from "./TftBracketsContainer.vue?vue&type=script&lang=js"
export * from "./TftBracketsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports